module.exports = __webpack_public_path__ + "img/ganxi05.6203167a.png";